import { lnv } from '@shared/scores.js';
import type { ForcaDef } from './index.js';

type Props = { forca: ForcaDef; score: number };

export function ScoreCard({ forca, score }: Props) {
  const label = lnv(score);
  const pct = Math.round((score / 10) * 100);

  return (
    <article
      className="min-w-[100px] border-t-4 bg-ha-card2 p-3 text-center"
      style={{ borderColor: forca.hex }}
    >
      <p className="text-2xl font-black" style={{ color: forca.texto }}>
        {score.toFixed(1).replace('.', ',')}
      </p>
      <p className="text-[10px] text-ha-muted">/10</p>
      <p className="mt-1 text-[9px] font-bold uppercase tracking-wide" style={{ color: forca.texto }}>
        {label}
      </p>
      <p className="mt-2 h-1 w-full bg-ha-border" role="presentation">
        <span className="block h-full" style={{ width: `${pct}%`, background: forca.hex }} />
      </p>
      <p className="mt-2 text-[8px] font-extrabold uppercase">{forca.nome}</p>
    </article>
  );
}
